<div id="app-root" [ngClass]="{'no-scroll': noScroll}">
  <router-outlet></router-outlet>
  <app-cookie></app-cookie>
</div>
